import React from 'react';
import { RouteComponentProps } from 'react-router';
import { NavItem } from 'common/HorizontalNavPage';
import { PermissionName } from '@utmost.co/enterprise-models';
import { LaunchDarklyFeatureFlagKeys } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';
import { CustomFieldDefinitions } from '../CustomFieldDefinitions/CustomFieldDefinitions';
import { Objects } from '../Objects/Objects';

export enum CUSTOM_FIELDS_AND_OBJECTS_TAB {
  OBJECTS = 'objects',
  CUSTOM_FIELDS = 'custom-fields'
}

export interface CustomFieldsAndObjectsNavItem extends NavItem {
  pathSchema: string;
  component:
    | React.ComponentType<React.PropsWithChildren<RouteComponentProps<any>>>
    | React.ComponentType<React.PropsWithChildren<any>>;
  useDarkly?: LaunchDarklyFeatureFlagKeys;
}

export const defaultPath = CUSTOM_FIELDS_AND_OBJECTS_TAB.CUSTOM_FIELDS;

export const PATH_SCHEMA = '/settings/custom-fields-and-objects';

export const navItems: CustomFieldsAndObjectsNavItem[] = [
  getDefaults(CUSTOM_FIELDS_AND_OBJECTS_TAB.CUSTOM_FIELDS, CustomFieldDefinitions, 'CUSTOM_FIELD_DEFINITION'),
  getDefaults(CUSTOM_FIELDS_AND_OBJECTS_TAB.OBJECTS, Objects, 'CUSTOM_FIELD_DEFINITION')
];

function getDefaults(
  tab: CUSTOM_FIELDS_AND_OBJECTS_TAB,
  component:
    | React.ComponentType<React.PropsWithChildren<RouteComponentProps<any>>>
    | React.ComponentType<React.PropsWithChildren<any>>,
  staticPermission?: PermissionName,
  useDarkly?: LaunchDarklyFeatureFlagKeys
): CustomFieldsAndObjectsNavItem {
  return {
    label: `custom-fields-and-objects.${tab}`,
    path: tab,
    pathSchema: `/:tenantCode${PATH_SCHEMA}/${tab}`,
    'data-test': `${tab}__settings__tab`,
    component,
    permissions: staticPermission ? [{ name: staticPermission, action: 'READ' }] : [],
    useDarkly
  };
}
